var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('header', {
    staticClass: "header"
  }, [_c('div', {
    staticClass: "header-primary-container"
  }, [_c('div', {
    staticClass: "header-primary"
  }, [_c('div', {
    staticClass: "header-primary__contents"
  }, [_c('div', {
    staticClass: "header-primary__forward"
  }, [_c('div', {
    staticClass: "header-logo"
  }, [_c('h1', [_c('router-link', {
    attrs: {
      "to": "/",
      "title": "홈으로 이동"
    }
  }, [_c('span', {
    staticClass: "blind"
  }, [_vm._v("SBA 국제유통센터")])])], 1)]), _vm._m(0)]), _c('div', {
    staticClass: "header-primary__body"
  }, [_c('div', {
    staticClass: "header-primary__main"
  }, [_c('div', {
    staticClass: "header-primary__main-inner"
  }, [_c('ul', {
    staticClass: "header-menu-lists"
  }, [_c('li', {
    staticClass: "header-menu-list"
  }, [_c('router-link', {
    staticClass: "link",
    attrs: {
      "to": "/about"
    }
  }, [_c('h2', [_vm._v("페이지소개")])])], 1), _c('li', {
    staticClass: "header-menu-list"
  }, [_c('router-link', {
    staticClass: "link",
    attrs: {
      "to": "/fairs"
    }
  }, [_c('h2', [_vm._v("매칭상담회")])])], 1), _c('li', {
    staticClass: "header-menu-list"
  }, [_c('router-link', {
    staticClass: "link",
    attrs: {
      "to": "/center/faqs"
    }
  }, [_c('h2', [_vm._v("자주 묻는 질문")])])], 1), _c('li', {
    staticClass: "header-menu-list"
  }, [_c('router-link', {
    staticClass: "link",
    attrs: {
      "to": "/center/notice"
    }
  }, [_c('h2', [_vm._v("공지사항")])])], 1)]), _c('div', {
    staticClass: "header-primary-dimmed"
  })])])]), _c('div', {
    staticClass: "header-primary__right"
  }, [_c('ul', {
    staticClass: "header-customer-lists"
  }, [_c('li', [_c('gnb-login-button')], 1), _c('li', [_c('router-link', {
    attrs: {
      "to": "/mypage/myinfo"
    }
  }, [_c('span', [_vm._v("마이페이지")])])], 1)])])])])]), _c('div', {
    staticClass: "mobile-sidebar"
  }, [_c('div', {
    staticClass: "mobile-sidebar__head"
  }, [_vm._m(1), _c('locale-select')], 1), _c('div', {
    staticClass: "mobile-sidebar__body"
  }, [_c('ul', {
    staticClass: "mobile-category__lists"
  }, [_c('li', {
    staticClass: "mobile-category__list",
    attrs: {
      "data-category-order": ""
    }
  }, [_c('router-link', {
    staticClass: "mobile-category__list-link",
    attrs: {
      "to": "/about"
    }
  }, [_c('span', [_vm._v("페이지 소개")])])], 1), _c('li', {
    staticClass: "mobile-category__list",
    attrs: {
      "data-category-order": ""
    }
  }, [_c('router-link', {
    staticClass: "mobile-category__list-link",
    attrs: {
      "to": "/fairs"
    }
  }, [_c('span', [_vm._v("매칭상담회")])])], 1), _c('li', {
    staticClass: "mobile-category__list",
    attrs: {
      "data-category-order": ""
    }
  }, [_c('router-link', {
    staticClass: "mobile-category__list-link",
    attrs: {
      "to": "/center/faqs"
    }
  }, [_c('span', [_vm._v("자주 묻는 질문")])])], 1), _c('li', {
    staticClass: "mobile-category__list",
    attrs: {
      "data-category-order": ""
    }
  }, [_c('router-link', {
    staticClass: "mobile-category__list-link",
    attrs: {
      "to": "/center/notice"
    }
  }, [_c('span', [_vm._v("공지사항")])])], 1)])]), _c('div', {
    staticClass: "mobile-sidebar__foot"
  }, [_c('ul', {
    staticClass: "mobile-foot-link"
  }, [_c('li', [_c('gnb-login-button')], 1), _c('li', [_c('router-link', {
    attrs: {
      "to": "/mypage/myinfo"
    }
  }, [_c('span', [_vm._v("마이페이지")])])], 1)])])]), _c('div', {
    staticClass: "mobile-sidebar-dimmed"
  })]);
}
var staticRenderFns = [function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "mobile-menu"
  }, [_c('button', {
    staticClass: "button",
    attrs: {
      "type": "button",
      "aria-pressed": "false"
    }
  }, [_c('span')])]);
},function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('button', {
    staticClass: "mobile-sidebar__close",
    attrs: {
      "type": "button"
    }
  }, [_c('span', {
    staticClass: "blind"
  }, [_vm._v("모바일 메뉴바 닫기")])]);
}]

export { render, staticRenderFns }